import React from 'react'
import styled from 'styled-components'
import { Color } from './color'
import grey3Bottom from './grey3-bottom.svg'
import grey3Top from './grey3-top.svg'
import grey4Bottom from './grey4-bottom.svg'
import grey4Top from './grey4-top2.svg'
import grey5Bottom from './grey5-bottom.svg'
import grey5Top from './grey5-top.svg'
import grey6Bottom from './grey6-bottom.svg'
import grey6Top from './grey6-top.svg'
import blueWave from './illu-fond.svg'
import blueRectangle from './rectangle.svg'

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const ContentSection = styled.section`
  max-width: 700px;
  margin: auto;
  display: block;
`

// blue section curves must be white masks
// because the section background has a texture
// which can't be reproduced in the curve image
export const BlueSection: React.FC<{
  className?: string
}> = ({ className, children }) => (
  <Section className={className}>
    <TopSeparator viewBox="0 0 1440 34">
      <g stroke="none" fillRule="evenodd" fill={Color.white}>
        <path d="M3.65342446e-12,1.9265521 C380.040977,1.9265521 481.205036,33.8334354 720,33.8334354 C958.794964,33.8334354 1043.25018,1.9265521 1440,1.9265521 C1440,1.9265521 1440,1.31556621 1440,0.0935944389 L1.59161573e-12,0.0935944389 C2.22234804e-13,1.31556621 9.0950438e-13,1.9265521 3.65342446e-12,1.9265521 Z" />
      </g>
    </TopSeparator>
    {children}
    <BlueSectionBottomDivider />
  </Section>
)

export const BlueSectionBottomDivider = () => (
  <BottomSeparator viewBox="0 0 1440 36">
    <g
      stroke="none"
      strokeWidth="1"
      transform="translate(0.000000, -475.000000)"
      fill={Color.white}
      fillRule="evenodd"
    >
      <path d="M-1.13686838e-13,510.939565 C380.040977,510.939565 1043.25018,510.939565 1440,510.939565 C1440,510.939565 1440,499.279937 1440,475.960682 C1129.247,498.155477 889.246996,508.398985 720,506.691206 C550.753004,504.983427 310.753004,494.739919 -1.13686838e-13,475.960682 C-1.13686838e-13,499.279937 -1.13686838e-13,510.939565 -1.13686838e-13,510.939565 Z" />
    </g>
  </BottomSeparator>
)

const DefautBcg = styled(Section)<{ url: string; minHeight: string }>`
  background: ${props => `url(${props.url})`};
  min-height: ${props => props.minHeight};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`

// grey section separators can be outside the section
// so that the section can overlap the blue section
export const GreySection: React.FC<{ className?: string }> = ({
  className,
  children,
}) => (
  <div className={className}>
    <OutsideTopSeparator viewBox="0 0 1440 107">
      <g stroke="none" fill="#f2f8ff" fillRule="evenodd">
        <path
          d="M7.92415802e-11,0.919869865 C214.221496,0.919869865 454.873513,55.4326106 720,54.4125529 C970.727574,53.447894 1246.35561,-3.17705449 1440,0.919869865 C1440,0.919869865 1440,36.0450259 1440,106.295338 L7.68523023e-11,106.295338 C7.60522965e-11,36.0450259 7.68487224e-11,0.919869865 7.92415802e-11,0.919869865 Z"
          transform="translate(720.000000, 53.501596) scale(-1, 1) translate(-720.000000, -53.501596) "
        />
      </g>
    </OutsideTopSeparator>
    <GreySectionWrapper>{children}</GreySectionWrapper>
    <Separator viewBox="0 0 1440 82">
      <g
        stroke="none"
        fill="#f2f8ff"
        fillRule="evenodd"
        transform="translate(0.000000, -475.000000)"
      >
        <path d="M1.59161573e-12,425.888487 C380.040977,425.888487 1043.25018,425.888487 1440,425.888487 C1440,425.888487 1440,442.579219 1440,475.960682 C1129.247,498.155477 889.246996,508.398985 720,506.691206 C550.753004,504.983427 310.753004,494.739919 3.65274227e-12,475.960682 C2.27865791e-12,442.579219 1.59161573e-12,425.888487 1.59161573e-12,425.888487 Z" />
      </g>
    </Separator>
  </div>
)

export const Grey2Section: React.FC<{ className?: string }> = ({
  className,
  children,
}) => (
  <div>
    <OutsideTopSeparator viewBox="0 0 1440 107">
      <g stroke="none" fill="#f1f4fb" fillRule="evenodd">
        <path
          d="M7.92415802e-11,0.919869865 C214.221496,0.919869865 454.873513,55.4326106 720,54.4125529 C970.727574,53.447894 1246.35561,-3.17705449 1440,0.919869865 C1440,0.919869865 1440,36.0450259 1440,106.295338 L7.68523023e-11,106.295338 C7.60522965e-11,36.0450259 7.68487224e-11,0.919869865 7.92415802e-11,0.919869865 Z"
          transform="translate(720.000000, 53.501596) scale(-1, 1) translate(-720.000000, -53.501596) "
        />
      </g>
    </OutsideTopSeparator>
    <Grey2SectionWrapper className={className}>{children}</Grey2SectionWrapper>
    <Separator viewBox="0 0 1440 82">
      <g
        stroke="none"
        fill="#f1f4fb"
        fillRule="evenodd"
        transform="translate(0.000000, -475.000000)"
      >
        <path d="M1.59161573e-12,425.888487 C380.040977,425.888487 1043.25018,425.888487 1440,425.888487 C1440,425.888487 1440,442.579219 1440,475.960682 C1129.247,498.155477 889.246996,508.398985 720,506.691206 C550.753004,504.983427 310.753004,494.739919 3.65274227e-12,475.960682 C2.27865791e-12,442.579219 1.59161573e-12,425.888487 1.59161573e-12,425.888487 Z" />
      </g>
    </Separator>
  </div>
)

export const Grey3Section: React.FC<{ className?: string }> = ({
  className,
  children,
}) => (
  <div>
    <DefautBcg url={grey3Top} minHeight={'20px'} />
    <Grey3SectionWrapper className={className}>{children}</Grey3SectionWrapper>
    <DefautBcg url={grey3Bottom} minHeight={'25px'} />
  </div>
)
export const Grey4Section: React.FC<{ className?: string }> = ({
  className,
  children,
}) => (
  <div>
    <DefautBcg url={grey4Top} minHeight={'35px'} />
    <Grey3SectionWrapper className={className}>{children}</Grey3SectionWrapper>
    <DefautBcg url={grey4Bottom} minHeight={'50px'} />
  </div>
)
export const Grey5Section: React.FC<{ className?: string }> = ({
  className,
  children,
}) => (
  <div>
    <DefautBcg url={grey5Top} minHeight={'10px'} />
    <Grey3SectionWrapper className={className}>{children}</Grey3SectionWrapper>
    <DefautBcg url={grey5Bottom} minHeight={'15px'} />
  </div>
)

export const Grey6Section: React.FC<{ className?: string }> = ({
  className,
  children,
}) => (
  <div>
    <DefautBcg url={grey6Top} minHeight={'40px'} />
    <Grey3SectionWrapper className={className}>{children}</Grey3SectionWrapper>
    <DefautBcg url={grey6Bottom} minHeight={'10px'} />
  </div>
)

const GreySectionWrapper = styled(Section)`
  background-color: #f2f8ff;
`

const Grey2SectionWrapper = styled(Section)`
  background-color: #f1f4fb;
`
const Grey3SectionWrapper = styled(Section)`
  background-color: #f0f4fb;
`

export const HeroP2IA = styled(Section)`
  background: url(${blueWave}), url(${blueRectangle});
  background-repeat: no-repeat, no-repeat;
`

const Separator = styled.svg`
  width: 100%;
  display: block;
`

const OutsideTopSeparator = styled(Separator)`
  top: 1px;
  position: relative;
`

export const TopSeparator = styled(Separator)`
  position: absolute;
  top: -1px;
`

const BottomSeparator = styled(Separator)`
  position: absolute;
  bottom: -3px;
`

export const AriaLiveSection = styled.div.attrs({
  role: 'status',
  'aria-live': 'polite',
})`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap; /* added line */
  border: 0;
`
